var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24996 3.33331C3.71871 3.33331 1.66663 5.3854 1.66663 7.91665C1.66663 12.5 7.08329 16.6666 9.99996 17.6358C12.9166 16.6666 18.3333 12.5 18.3333 7.91665C18.3333 5.3854 16.2812 3.33331 13.75 3.33331C12.2 3.33331 10.8291 4.1029 9.99996 5.28081C9.57733 4.67882 9.01586 4.18752 8.3631 3.84852C7.71034 3.50952 6.9855 3.33279 6.24996 3.33331Z",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.d4da2aa78823a450fd26655d362fca67.svg";
export { ForwardRef as ReactComponent };